import * as React from 'react';

import GenericIconProps from './_icon.type';

function EmailSquareIcon({ className = 'w-4 h-4 fill-site-neutrals-800' }: GenericIconProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="6" />
      <g mask="url(#mask0_1125_12256)">
        <path
          d="M5.50525 17.9995C5.09275 17.9995 4.73962 17.8526 4.44587 17.5587C4.15212 17.2648 4.00525 16.9115 4.00525 16.4987V7.49368C4.00525 7.0809 4.15212 6.72868 4.44587 6.43701C4.73962 6.14535 5.09275 5.99951 5.50525 5.99951H18.5052C18.9177 5.99951 19.2709 6.14646 19.5646 6.44034C19.8584 6.73423 20.0052 7.08757 20.0052 7.50034V16.5053C20.0052 16.9181 19.8584 17.2703 19.5646 17.562C19.2709 17.8537 18.9177 17.9995 18.5052 17.9995H5.50525ZM12.0052 12.9995L5.50525 9.27035V16.4995H18.5052V9.27035L12.0052 12.9995ZM12.0052 11.2287L18.5052 7.49951H5.50525L12.0052 11.2287ZM5.50525 9.27035V7.49951V16.4995V9.27035Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export default EmailSquareIcon;
